import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

// --- Meta Pixel (970566142171718): base code + PageView ---
(function initMetaPixel() {
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];
  const t = document.createElement("script");
  t.async = true;
  t.src = "https://connect.facebook.net/en_US/fbevents.js";
  const s = document.getElementsByTagName("script")[0];
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s);
  } else {
    document.head.appendChild(t);
  }
  w.fbq("init", "970566142171718");
  w.fbq("track", "PageView");
})();

// --- GA4 (G-C4JZKB2BFQ): this page had Meta Pixel wired but no GA4, so any
// Google-attributed spend against it was going uncounted (2026-08-18 handoff). ---
(function initGA4() {
  const w = window as any;
  w.dataLayer = w.dataLayer || [];
  function gtag(...args: any[]) {
    w.dataLayer.push(args);
  }
  w.gtag = gtag;
  gtag("js", new Date());
  gtag("config", "G-C4JZKB2BFQ");
  const t = document.createElement("script");
  t.async = true;
  t.src = "https://www.googletagmanager.com/gtag/js?id=G-C4JZKB2BFQ";
  document.head.appendChild(t);
})();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-240" data-mp="1odwjrkuq7eir" />);
}